export function handleResponse(status = 0, data: any) {
  if (status == 200){
    return {
      success: true,
      data: null,
      status: status
    };
  } else {
    return {
      success: false,
      data: null,
      status: 400,
    };
  }
}

export function handleResponseError(errorResponse: any){
  return {
    success: false,
    status: errorResponse?.status,
    message: errorResponse?.message
  };
}